var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23C29.7761 23 30 22.7761 30 22.5C30 22.2239 29.7761 22 29.5 22C29.2239 22 29 22.2239 29 22.5C29 22.7761 29.2239 23 29.5 23Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 27C33.7761 27 34 26.7761 34 26.5C34 26.2239 33.7761 26 33.5 26C33.2239 26 33 26.2239 33 26.5C33 26.7761 33.2239 27 33.5 27Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24C24.7761 24 25 23.7761 25 23.5C25 23.2239 24.7761 23 24.5 23C24.2239 23 24 23.2239 24 23.5C24 23.7761 24.2239 24 24.5 24Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29C22.7761 29 23 28.7761 23 28.5C23 28.2239 22.7761 28 22.5 28C22.2239 28 22 28.2239 22 28.5C22 28.7761 22.2239 29 22.5 29Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C22.5 18 18 22.5 18 28C18 33.5 22.5 38 28 38C28.926 38 29.648 37.254 29.648 36.312C29.648 35.875 29.468 35.477 29.211 35.187C28.921 34.898 28.773 34.535 28.773 34.062C28.7692 33.8419 28.8098 33.6233 28.8922 33.4192C28.9747 33.2151 29.0975 33.0298 29.2531 32.8741C29.4088 32.7185 29.5941 32.5957 29.7982 32.5132C30.0023 32.4308 30.2209 32.3902 30.441 32.394H32.437C35.488 32.394 37.992 29.891 37.992 26.84C37.965 22.012 33.461 18 28 18Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.48e62493baf283f7b4207a12c271dd01.svg";
export { ForwardRef as ReactComponent };